import React, { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import './DashboardCard.css'; // Importing the isolated CSS file

const DashboardCard = ({
    icon: Icon,
    title,
    value,
    trendValue,
    isPositive,
    colorClass = "blue"
}) => {

    return (
        <div className="dashboard-card">
            <div className="card-header">
                <div className={`icon-container ${colorClass}`}>
                    {Icon && <Icon size={24} />}
                </div>
                <span className="card-title">{title}</span>
            </div>

            <div className="card-body">
                <h2 className="card-value">{value}</h2>

                {trendValue && (
                    <div className={`card-trend ${isPositive ? 'positive' : 'negative'}`}>
                        {isPositive ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
                        <span>{trendValue}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardCard;